import { Action } from '@ngrx/store';
import { ArrearsDrillDownParams } from '../models/arrears-drilldown-params.model';

export const ENTER_DRILLDOWN_MODE = '[Arrears Drill Down] Enter';
export const EXIT_DRILLDOWN_MODE = '[Arrears Drill Down] Exit';

export class BeginDrillDownPayload {
  widgetId: string;
  drillDownParams: ArrearsDrillDownParams;
}

export class ExitDrillDownPayload {
  widgetId: string;
}

export class BeginDrillDown implements Action {
  readonly type = ENTER_DRILLDOWN_MODE;
  constructor(public payload: BeginDrillDownPayload | any ) { }
}

export class ExitDrillDown implements Action {
  readonly type = EXIT_DRILLDOWN_MODE ;
  constructor(public payload: ExitDrillDownPayload | any) { }
}

export type Actions =
  BeginDrillDown |
  ExitDrillDown;
